import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const usePlacesState = () => React.useContext(Context) || {}
export const usePlaces = () => usePlacesState()?.places || []

const QUERY = gql`
  query Places($search: String, $sort: PlaceSort, $filter: PlaceFilter) {
    places(page: 1, limit: 90000, search: $search, sort: $sort, filter: $filter) {
      id
      name
      resume
      type
    }
  }
`

const PlacesLoader = ({ children, search, filter, uncontrolledChildren, noEmptyMessage }) => {
  const { data, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      search,
      sort: { field: 'NAME', type: 'ASC' },
      filter
    },
    client: placesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} noEmptyMessage={noEmptyMessage}>
        {children}
        <LazyAction disabled={true} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default PlacesLoader
